import React from "react";
import Layout from "../components/layout";
import { FileText } from "lucide-react";

const documents = [
  {
    id: 1,
    title: "Salary Slip - March 2025",
    uploadedOn: "2025-04-01",
    url: "/docs/march-2025-salary-slip.pdf",
  },
  {
    id: 2,
    title: "HR Policy Document",
    uploadedOn: "2025-03-15",
    url: "/docs/hr-policy.pdf",
  },
  {
    id: 3,
    title: "IT Declaration Form",
    uploadedOn: "2025-02-10",
    url: "/docs/it-declaration.pdf",
  },
];

const MyDocuments = () => {
  return (
    <Layout>
      <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
        <h1 className="text-2xl font-semibold mb-6 text-gray-800">Documents</h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {documents.map((doc) => (
            <div
              key={doc.id}
              className="bg-white rounded-2xl shadow hover:shadow-lg transition p-5 flex flex-col gap-2"
            >
              <div className="flex items-center gap-3">
                <FileText className="text-indigo-500 w-6 h-6" />
                <h2 className="text-lg font-semibold text-gray-800">{doc.title}</h2>
              </div>
              <p className="text-sm text-gray-500">Uploaded on: {doc.uploadedOn}</p>
              <a
                href={doc.url}
                download
                className="mt-3 inline-block bg-indigo-600 hover:bg-indigo-700 text-white text-sm px-4 py-2 rounded-xl text-center"
              >
                Download
              </a>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default MyDocuments;